import React, { useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { submitAssessmentForStudent } from '../../helper/progress_helper';
import { toast } from 'react-toastify';

const Assessment = ({ fetchCourse, setShowAssessment, questions, moduleId, setLoader }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [userAnswers, setUserAnswers] = useState({});
    const [result, setResult] = useState(null);

    // Handle answer selection
    const handleAnswerChange = (questionId, selectedAnswer) => {
        setUserAnswers({
            ...userAnswers,
            [questionId]: selectedAnswer
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowAssessment(false);
        let score = 0;
        questions.forEach((question) => {
            const correctAnswer = question.answer;
            const userAnswer = userAnswers[question.id];
            if (userAnswer === correctAnswer) {
                score++;
            }
        });
        setResult(`You scored ${score} out of ${questions.length}`);

        const studentId = JSON.parse(localStorage.getItem("student")).id;
        console.log()
        try {
            setLoader(true);
            const data = await submitAssessmentForStudent(studentId + "/" + moduleId + "/" + score);
            if (data?.success) {
                toast.success(data?.message);
                console.log("fetchCourse");
                fetchCourse();
            } else {
                toast.error(data?.message);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    // Navigate to the next question
    const handleNextQuestion = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    // Navigate to the previous question
    const handlePreviousQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    // Get current question
    const currentQuestion = questions[currentQuestionIndex];

    return (
        <div style={{...styles.container, padding: isMobile ? '10px' : '20px' }}>
            <h1 style={{...styles.title, fontSize: isMobile ? '1.5rem' : '2rem' }}>Assessment</h1>

            {/* Submit button at the top */}
            <form style={styles.form}>
                <div style={styles.topButtonContainer}>
                    {currentQuestionIndex === questions.length - 1 && (
                        <button onClick={handleSubmit} style={{...styles.submitButton, width: isMobile ? '100%' : 'auto' }}>
                            Submit
                        </button>
                    )}
                </div>

                <div style={styles.questionBox}>
                    <div style={{...styles.progressText, fontSize: isMobile ? '16px' : '18px' }}>
                        Question {currentQuestionIndex + 1} of {questions.length}
                    </div>
                    <h3 style={{...styles.questionText, fontSize: isMobile ? '1.1rem' : '1.25rem' }}>
                        {currentQuestionIndex + 1}. {currentQuestion.description}
                    </h3>
                    <div style={styles.options}>
                        {currentQuestion.options.split(',').map((option, index) => (
                            <label key={index} style={{...styles.optionLabel, fontSize: isMobile ? '0.9rem' : '1rem' }}>
                                <div onClick={() => handleAnswerChange(currentQuestion.id, option)}>
                                    <input
                                        type="radio"
                                        name={`question-${currentQuestion.id}`}
                                        value={option}
                                        checked={userAnswers[currentQuestion.id] === option}
                                        style={{...styles.radioButton, marginRight: isMobile ? '8px' : '10px' }}
                                    />
                                    {option}
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                <div style={{...styles.navigationButtons, flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0 }}>
                    {currentQuestionIndex > 0 && (
                        <button type="button" onClick={handlePreviousQuestion} style={{...styles.prevButton, width: isMobile ? '100%' : 'auto' }}>
                            Previous Question
                        </button>
                    )}
                    {currentQuestionIndex < questions.length - 1 && (
                        <button type="button" onClick={handleNextQuestion} style={{...styles.nextButton, width: isMobile ? '100%' : 'auto' }}>
                            Next Question
                        </button>
                    )}
                </div>
            </form>
            {result && <h2 style={{...styles.result, fontSize: isMobile ? '1.25rem' : '1.5rem' }}>{result}</h2>}
        </div>
    );
};

// Inline styles for the component
const styles = {
    progressText: {
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "10px",
        color: "#333",
    },
    container: {
        // maxWidth: '600px',
        margin: '0 auto',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
    },
    title: {
        textAlign: 'center',
        color: '#333',
        marginBottom: '20px'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        overflow: 'hidden'
    },
    topButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px'
    },
    questionBox: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
        textAlign: 'left'
    },
    questionText: {
        color: '#444',
        marginBottom: '10px'
    },
    options: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    optionLabel: {
        display: 'flex',
        alignItems: 'center',
        color: '#555',
        padding: '8px 0',
        cursor: 'pointer'
    },
    radioButton: {
    },
    navigationButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '20px'
    },
    prevButton: {
        padding: '10px 20px',
        backgroundColor: '#6c757d',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease',
        alignSelf: 'center'
    },
    nextButton: {
        padding: '10px 20px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease',
        alignSelf: 'center'
    },
    submitButton: {
        padding: '10px 20px',
        backgroundColor: '#28a745',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease',
        alignSelf: 'center'
    },
    result: {
        textAlign: 'center',
        color: '#28a745',
        marginTop: '20px'
    }
};

export default Assessment;